import React, { useState } from "react";
import CustomModal from "./CustomModal";
import AuthInput from "../Input/AuthInput";
import { useDispatch, useSelector } from "react-redux";
import AddingLightLoader from "../Loaders/AddingLightLoader";
import { ErrorToast, SuccessToast, WarningToast } from "../../utils/ShowToast";
import { EditInvestorApi } from "../../ApiRequests"; // Updated API function
import AuthBtn from "../Buttons/AuthBtn";
import { fetchInvestor } from "../../store/Slices/InvestorSlice";

const EditInvestorModal = ({ Open, setOpen, currentInvestor }) => {
  const [Name, setName] = useState(currentInvestor ? currentInvestor.name : "");
  const [Contact, setContact] = useState(
    currentInvestor ? currentInvestor.contact : ""
  );
  const [Address, setAddress] = useState(
    currentInvestor ? currentInvestor.address : ""
  );
  const [Email, setEmail] = useState(
    currentInvestor ? currentInvestor.email : ""
  ); // Added Email state
  const [Loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (Name === "") {
      WarningToast("Enter a valid name");
    } else if (Contact === "") {
      WarningToast("Enter a valid contact number");
    } else if (Address === "") {
      WarningToast("Enter a valid address");
    } else if (Email === "" || !/\S+@\S+\.\S+/.test(Email)) {
      WarningToast("Enter a valid email");
    } else {
      try {
        const response = await EditInvestorApi(currentInvestor._id, {
          name: Name,
          contact: Contact,
          address: Address,
          email: Email, // Added Email to API request
        });
        if (response.data.success) {
          setOpen(false);
          SuccessToast("Investor Updated successfully");
          dispatch(fetchInvestor());
        } else {
          ErrorToast(response.data.error?.msg);
        }
      } catch (err) {
        console.log(err);
        ErrorToast("Failed to Update investor");
      }
    }
    setLoading(false);
  };

  return (
    <CustomModal open={Open} setOpen={setOpen}>
      <div className="pb-8">
        <h1 className="w-full text-center font-[700] text-3xl py-8">
          Update Investor
        </h1>
        <div className="flex flex-col px-10 gap-y-4">
          <AuthInput
            label="Name"
            placeholder="Enter Name"
            Value={Name}
            setValue={setName}
          />
          <AuthInput
            label="Contact"
            placeholder="Enter Contact"
            Value={Contact}
            setValue={setContact}
          />
          <AuthInput
            label="Address"
            placeholder="Enter Address"
            Value={Address}
            setValue={setAddress}
          />
          <AuthInput
            label="Email"
            placeholder="Enter Email"
            Value={Email}
            setValue={setEmail}
          />
        </div>
        <div className="flex justify-center items-center gap-x-2 mt-5 px-5">
          {Loading ? (
            <AddingLightLoader />
          ) : (
            <>
              <AuthBtn title={"Update Investor"} onSubmit={onSubmit} type={1} />
              <AuthBtn
                title={"Cancel"}
                onSubmit={() => setOpen(false)}
                type={2}
              />
            </>
          )}
        </div>
      </div>
    </CustomModal>
  );
};

export default EditInvestorModal;
